import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { guestGuard } from '@views/common/guards/guest.guard';
import { ProfessionalSection, siteRoutes } from '@views/common/models/routes.model';
import { ScrollPositionRestorationMode } from '@views/common/models/scroll-positions.model';
import { AnalyticsResolver } from '@views/common/resolver/analytics.resolver';
import { ProfessionalRoute } from './core/common/models/professionals-route.config';
import { AuthComponent } from './views/auth/components/auth.component';
import { BookingCreditFlyComponent } from './views/booking-credits-fly/booking-credit-fly.component';
import { BookingDetailComponent } from './views/booking-detail/booking-detail.component';
import { BookingListComponent } from './views/booking-list/booking-list.component';
import { sessionGuard } from './views/common/guards/session.guard';
import { HomeComponent } from './views/home/home.component';
import { homeResolver } from './views/home/resolver/home.resolver';
import { PageLayoutComponent } from './views/page-layout/page-layout.component';

export const routes: ProfessionalRoute[] = [
  {
    path: siteRoutes.Login,
    component: AuthComponent,
    section: ProfessionalSection,
    subSection: siteRoutes.Login,
    canActivate: [guestGuard],
    resolve: {
      digitalData: AnalyticsResolver
    }
  },
  {
    path: siteRoutes.Home,
    section: ProfessionalSection,
    subSection: siteRoutes.Home,
    component: HomeComponent,
    canActivate: [sessionGuard],
    resolve: {
      digitalData: AnalyticsResolver,
      init: homeResolver
    }
  },
  {
    path: '',
    redirectTo: siteRoutes.Home,
    pathMatch: 'full'
  },
  {
    path: '',
    component: PageLayoutComponent,
    canActivate: [sessionGuard],
    children: [
      {
        path: siteRoutes.BookingList,
        component: BookingListComponent,
        section: ProfessionalSection,
        subSection: siteRoutes.BookingList,
        resolve: {
          digitalData: AnalyticsResolver
        }
      },
      {
        path: siteRoutes.Booking,
        component: BookingDetailComponent,
        section: ProfessionalSection,
        subSection: siteRoutes.Booking,
        resolve: {
          digitalData: AnalyticsResolver
        }
      },
      {
        path: siteRoutes.Bookingscreditflight,
        component: BookingCreditFlyComponent,
        section: ProfessionalSection,
        subSection: siteRoutes.Bookingscreditflight,
        resolve: {
          digitalData: AnalyticsResolver
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: siteRoutes.Login
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: ScrollPositionRestorationMode.enabled
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
